import { shopClient } from '@portal-clients/shop';

import { useClientQuery } from '@frontend/hooks';

export interface UseShopProps {
  shopId: string;
  enabled?: boolean;
  onError?(error: Error): void;
}

export const getShopQueryKey = (shopId: string) => ['shop', shopId];

export const makeShopQueryOptions = (shopId: string) => ({
  queryKey: getShopQueryKey(shopId),
  queryFn: () => shopClient.get(shopId),
  staleTime: 0,
});

export const useShopQuery = ({ shopId, enabled, onError }: UseShopProps) => {
  const { queryKey, queryFn, staleTime } = makeShopQueryOptions(shopId);
  return useClientQuery({
    queryKey,
    onFetch: queryFn,
    onError,
    enabled,
    staleTime,
  });
};
